export default [
    {
        path: 'relatorio-historico-paciente',
        component: () => import(
            /* webpackChunkName: 'exame-laboratorial-relatorio-historico-paciente' */
            '@/views/exame-laboratorial/relatorio-historico-paciente/Index'
        ),
        redirect: 'relatorio-historico-paciente/index',
        children: [
            {
                name: 'exame-laboratorial-relatorio-historico-paciente-index',
                path: 'index',
                props: true,
                component: () => import(
                    /* webpackChunkName: 'exame-laboratorial-relatorio-historico-paciente' */
                    '@/views/exame-laboratorial/relatorio-historico-paciente/List.vue'
                ),
            },
        ],
    }
]